/**
 * Hair tab — extracted from ClientDetail.jsx (Feb 2026).
 *
 * Mirrors MakeupTab — same prop surface, same trial-handling callbacks.
 * Kept as a separate file because the headers and copy will diverge as
 * we add hair-only features (e.g., extension management).
 */
import React from "react";
import ArtistPicker from "@/components/ArtistPicker";
import AssistantsPicker from "@/components/AssistantsPicker";
import HairSheet from "@/pages/HairSheet";
import TrialBlock from "@/pages/TrialBlock";

export default function HairTab({ client, setClient, team, id, patch }) {
  return (
    <div className="space-y-6">
      <div className="bg-white border border-border rounded-sm p-6">
        <h2 className="font-serif-heading text-2xl">Scheda capelli professionale</h2>
        <p className="text-sm text-neutral-500 mt-1">Caratteristiche, trattamenti, acconciatura, accessori e foto prova.</p>
      </div>

      <ArtistPicker
        kind="hair"
        team={team}
        value={client.hair_artist_id || ""}
        onChange={(v) => patch("hair_artist_id", v)}
        testid="hair-artist-picker"
      />

      <AssistantsPicker
        team={team}
        value={client.assistant_ids || []}
        onChange={(v) => patch("assistant_ids", v)}
        testid="hair-assistants-picker"
      />

      <HairSheet client={client} onPatch={patch} />

      <div className="bg-white border border-border rounded-sm p-6">
        <TrialBlock
          kind="hair"
          client={client}
          clientId={id}
          onChange={(c) => setClient(c)}
          onSavedTrial={(k, t) => setClient((c) => ({ ...c, [k]: { ...(c[k] || {}), trial: t } }))}
        />
      </div>
    </div>
  );
}
